export default function NotesIcon({ small = false }: { small?: boolean }) {
  const size = small ? '18' : '20'
  return (
    <svg width={size} height={size} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.5 4.16699V5.83366M12.5 9.16699V10.8337M12.5 14.167V15.8337M4.16667 4.16699C3.72464 4.16699 3.30072 4.34259 2.98816 4.65515C2.67559 4.96771 2.5 5.39163 2.5 5.83366V8.33366C2.94203 8.33366 3.36595 8.50925 3.67851 8.82181C3.99107 9.13438 4.16667 9.5583 4.16667 10.0003C4.16667 10.4424 3.99107 10.8663 3.67851 11.1788C3.36595 11.4914 2.94203 11.667 2.5 11.667V14.167C2.5 14.609 2.67559 15.0329 2.98816 15.3455C3.30072 15.6581 3.72464 15.8337 4.16667 15.8337H15.8333C16.2754 15.8337 16.6993 15.6581 17.0118 15.3455C17.3244 15.0329 17.5 14.609 17.5 14.167V11.667C17.058 11.667 16.634 11.4914 16.3215 11.1788C16.0089 10.8663 15.8333 10.4424 15.8333 10.0003C15.8333 9.5583 16.0089 9.13438 16.3215 8.82181C16.634 8.50925 17.058 8.33366 17.5 8.33366V5.83366C17.5 5.39163 17.3244 4.96771 17.0118 4.65515C16.6993 4.34259 16.2754 4.16699 15.8333 4.16699H4.16667Z'
        stroke='currentColor'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
